function initP7DynamicSlider(sliderBlock) {
    if (!sliderBlock || sliderBlock.classList.contains('p7-slider-initialized')) return;

    const mainSliderEl = sliderBlock.querySelector('.p7-posts-slider-main');
    if (!mainSliderEl) return;

    const autoPlay = sliderBlock.dataset.autoplay === 'true';
    const delay = parseInt(sliderBlock.dataset.delay, 10) || 3000;
    const loop = sliderBlock.dataset.loop === 'true';
    const slidesPerView = parseInt(sliderBlock.dataset.slidesPerView, 10) || 4;

    const slideNumberEl = sliderBlock.querySelector('.slide-number');
    const progressBarEl = sliderBlock.querySelector('.progress-bar');

    const mainSwiper = new Swiper(mainSliderEl, {
        slidesPerView: slidesPerView,
        spaceBetween: 20,
        loop,
        speed: 500,

        slidesPerGroup: slidesPerView,

        autoplay: autoPlay ? {
            delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        } : false,

        navigation: {
            nextEl: sliderBlock.querySelector('.swiper-post-button-next'),
            prevEl: sliderBlock.querySelector('.swiper-post-button-prev')
        },

        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1025: {
                slidesPerView: slidesPerView,
                slidesPerGroup: slidesPerView,
            }
        }
    });

    function formatNumber(num) {
        return num < 10 ? '0' + num : num;
    }

    /* ===== FIX ONLY HERE ===== */
    function updateTopInfo() {
        const slidesPerView = mainSwiper.params.slidesPerView;
        const totalSlides = mainSwiper.slides.length;
        const totalPages = Math.max(1, Math.ceil(totalSlides / slidesPerView));

        const currentIndex = mainSwiper.realIndex || 0;
        let currentPage = Math.floor(currentIndex / slidesPerView) + 1;
        if (currentPage > totalPages) currentPage = totalPages;

        if (slideNumberEl) {
            slideNumberEl.innerHTML = `<span class="active">${formatNumber(currentPage)}</span>/${formatNumber(totalPages)}`;
        }

        if (progressBarEl) {
            progressBarEl.style.width = `${(currentPage / totalPages) * 100}%`;
        }
    }

    updateTopInfo();
    mainSwiper.on('slideChange', updateTopInfo);
    mainSwiper.on('slidesLengthChange', updateTopInfo);

    /* ===== KEEP YOUR DYNAMIC LOGIC ===== */
    let appendNumber = mainSwiper.slides.length + 1;
    let prependNumber = 0;

    const prependBtn = sliderBlock.querySelector('.prepend-slide');
    const appendBtn = sliderBlock.querySelector('.append-slide');
    const prepend2Btn = sliderBlock.querySelector('.prepend-2-slides');
    const append2Btn = sliderBlock.querySelector('.append-2-slides');

    if (prependBtn) {
        prependBtn.addEventListener('click', e => {
            e.preventDefault();
            mainSwiper.prependSlide(`<div class="swiper-slide">Slide ${--prependNumber}</div>`);
            updateTopInfo();
        });
    }

    if (appendBtn) {
        appendBtn.addEventListener('click', e => {
            e.preventDefault();
            mainSwiper.appendSlide(`<div class="swiper-slide">Slide ${++appendNumber}</div>`);
            updateTopInfo();
        });
    }

    if (prepend2Btn) {
        prepend2Btn.addEventListener('click', e => {
            e.preventDefault();
            mainSwiper.prependSlide([
                `<div class="swiper-slide">Slide ${--prependNumber}</div>`,
                `<div class="swiper-slide">Slide ${--prependNumber}</div>`
            ]);
            updateTopInfo();
        });
    }

    if (append2Btn) {
        append2Btn.addEventListener('click', e => {
            e.preventDefault();
            mainSwiper.appendSlide([
                `<div class="swiper-slide">Slide ${++appendNumber}</div>`,
                `<div class="swiper-slide">Slide ${++appendNumber}</div>`
            ]);
            updateTopInfo();
        });
    }

    sliderBlock.classList.add('p7-slider-initialized');
    sliderBlock.swiperInstance = mainSwiper;
}


/* ===== Init all sliders ===== */
function initializeAllP7DynamicSliders() {
    document
        .querySelectorAll('.p7-posts-slider-block:not(.p7-slider-initialized)')
        .forEach(initP7DynamicSlider);
}

/* Initial load */
document.addEventListener('DOMContentLoaded', () => {
    initializeAllP7DynamicSliders();
    setTimeout(initializeAllP7DynamicSliders, 1000);
});

/* Gutenberg support */
if (typeof wp !== 'undefined' && wp.data && wp.data.subscribe) {
    let timeout;
    wp.data.subscribe(() => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            document.querySelectorAll('.p7-posts-slider-block.p7-slider-initialized').forEach(block => {
                if (block.swiperInstance) {
                    block.swiperInstance.destroy(true, true);
                    block.classList.remove('p7-slider-initialized');
                }
            });
            initializeAllP7DynamicSliders();
        }, 120);
    });
}

/* Resize support */
if (window.frameElement && window.frameElement.classList.contains('is-resizable')) {
    const resizeObserver = new ResizeObserver(() => {
        setTimeout(initializeAllP7DynamicSliders, 60);
    });
    resizeObserver.observe(document.body);
}

/* Global API */
window.p7PostsSlider = {
    initSlider: initP7DynamicSlider,
    initAllSliders: initializeAllP7DynamicSliders,
    destroyAllSliders() {
        document.querySelectorAll('.p7-posts-slider-block.p7-slider-initialized').forEach(block => {
            if (block.swiperInstance) {
                block.swiperInstance.destroy(true, true);
                block.classList.remove('p7-slider-initialized');
            }
        });
    }
};
